import api from "../../../shared/api/apiClient";

const normalizeList = (data) => ({
  total: Number(data?.total || 0),
  items: Array.isArray(data?.items) ? data.items : [],
});

export const marketingApi = {
  async listCampaigns(params = {}) {
    const { data } = await api.get("/marketing/campaigns", { params });
    return normalizeList(data);
  },

  async getCampaign(id) {
    const { data } = await api.get(`/marketing/campaigns/${id}`);
    return data;
  },

  async createCampaign(payload) {
    const { data } = await api.post("/marketing/campaigns", payload);
    return data;
  },

  async updateCampaign(id, payload) {
    const { data } = await api.put(`/marketing/campaigns/${id}`, payload);
    return data;
  },

  async startCampaign(id, force = false) {
    const { data } = await api.post(`/marketing/campaigns/${id}/start`, { force });
    return data;
  },

  async cancelCampaign(id) {
    const { data } = await api.post(`/marketing/campaigns/${id}/cancel`);
    return data;
  },

  async testSend(id, payload) {
    const { data } = await api.post(`/marketing/campaigns/${id}/test-send`, payload);
    return data;
  },

  async sendCampaignToContacts(id, payload) {
    const { data } = await api.post(`/marketing/campaigns/${id}/send-to-contacts`, payload);
    return data;
  },

  async listRecipients(campaignId) {
    const { data } = await api.get(`/marketing/campaigns/${campaignId}/recipients`);
    return Array.isArray(data?.items) ? data.items : [];
  },

  async listCoupons(params = {}) {
    const { data } = await api.get("/marketing/coupons", { params });
    return normalizeList(data);
  },

  async createCoupon(payload) {
    const { data } = await api.post("/marketing/coupons", payload);
    return data;
  },

  async checkCoupon(payload) {
    const { data } = await api.post("/marketing/coupons/check", payload);
    return data;
  },

  async applyCoupon(payload) {
    const { data } = await api.post("/marketing/coupons/apply", payload);
    return data;
  },

  async listJobs(params = {}) {
    const { data } = await api.get("/marketing/jobs", { params });
    return Array.isArray(data?.items) ? data.items : [];
  },

  async processJobs() {
    const { data } = await api.post("/marketing/jobs/process");
    return data;
  },
};

export const contactsApiForMarketing = {
  async list(params = {}) {
    const { data } = await api.get("/contacts", { params });
    return {
      total: Number(data?.total || 0),
      items: Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [],
    };
  },
};
